import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const admessageService = {
    fetchAdMessages,
    createAdMessage,
    updateAdMessage,
    deleteAdMessage
};

function fetchAdMessages() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.admessage.fetchAdmessages, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function createAdMessage(admessageDetails) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.admessage.createAdmessage, admessageDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateAdMessage(admessageDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.admessage.updateAdmessage, admessageDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function deleteAdMessage(admessageId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.admessage.deleteAdmessage}/${admessageId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}